import { camelCase } from '../util.js'
const works = [
  {
    title: '洋河小海',
    desc: '洋河小海',
    thumb: camelCase('cases-brand-yanghe-0'),
    zpic: [
      camelCase('cases-brand-yanghe-lazyload-01')
    ]
  },
  {
    title: '空白档',
    desc: '空白档',
    thumb: camelCase('cases-brand-suning-5'),
    zpic: [
    ]
  },
  {
    title: '一转成双',
    desc: '一转成双',
    thumb: camelCase('cases-brand-yanghe-1'),
    zpic: [
      camelCase('cases-brand-yanghe-lazyload-11'),
      camelCase('cases-brand-yanghe-lazyload-12'),
      camelCase('cases-brand-yanghe-lazyload-13'),
      camelCase('cases-brand-yanghe-lazyload-14'),
      camelCase('cases-brand-yanghe-lazyload-15'),
      camelCase('cases-brand-yanghe-lazyload-16'),
      camelCase('cases-brand-yanghe-lazyload-17'),
      camelCase('cases-brand-yanghe-lazyload-18'),
      camelCase('cases-brand-yanghe-lazyload-19'),
      camelCase('cases-brand-yanghe-lazyload-110'),
      camelCase('cases-brand-yanghe-lazyload-111')
    ]
  },
  {
    title: '空白档',
    desc: '空白档',
    thumb: camelCase('cases-brand-suning-5'),
    zpic: [
    ]
  },
  {
    title: '梦之蓝',
    desc: '梦之蓝',
    thumb: camelCase('cases-brand-yanghe-2'),
    zpic: [
      camelCase('cases-brand-yanghe-lazyload-21'),
      camelCase('cases-brand-yanghe-lazyload-22'),
      camelCase('cases-brand-yanghe-lazyload-23'),
      camelCase('cases-brand-yanghe-lazyload-24'),
      camelCase('cases-brand-yanghe-lazyload-25'),
      camelCase('cases-brand-yanghe-lazyload-26'),
      camelCase('cases-brand-yanghe-lazyload-27'),
      camelCase('cases-brand-yanghe-lazyload-28'),
      camelCase('cases-brand-yanghe-lazyload-29'),
      camelCase('cases-brand-yanghe-lazyload-210')
    ]
  },
  {
    title: '梦之蓝——全球经济论坛',
    desc: '梦之蓝——全球经济论坛',
    thumb: camelCase('cases-brand-yanghe-3'),
    zpic: [
      camelCase('cases-brand-yanghe-lazyload-31')
    ]
  }
]
export default {
  name: '洋河',
  logo: {
    default: camelCase('cases-brand-8'),
    active: camelCase('cases-brand-8-cover')
  },
  works
}
